import clsx from "clsx"
import Autoplay from "embla-carousel-autoplay"
import Fade from "embla-carousel-fade"
import useEmblaCarousel from "embla-carousel-react"
import { useCallback } from "react"

import { faIcon } from "@utils/faIcon"

import { Icon, IconButton } from "@atoms"

import styles from "./Testimonials.module.scss"
import { TestimonialsProps } from "./Testimonials.types"
import useTestimonials from "./useTestimonials"

const TEN_SECONDS = 10000

export default function Testimonials(props: TestimonialsProps) {
    const { className } = props
    const { data: testimonials, isLoading } = useTestimonials()

    const [emblaRef, emblaApi] = useEmblaCarousel(
        {
            loop: true,
            align: "center",
        },
        [
            Autoplay({
                delay: TEN_SECONDS,
                stopOnInteraction: false,
                stopOnMouseEnter: true,
            }),
            Fade(),
        ],
    )

    const scrollPrev = useCallback(() => {
        if (emblaApi) {
            emblaApi.scrollPrev()
        }
    }, [emblaApi])

    const scrollNext = useCallback(() => {
        if (emblaApi) {
            emblaApi.scrollNext()
        }
    }, [emblaApi])

    if (isLoading || !testimonials || testimonials.length === 0) {
        return null
    }

    const showNavigation = testimonials.length > 1

    return (
        <div className={clsx(styles.base, "light-theme", className)}>
            <div className={styles.embla} ref={emblaRef}>
                <div className={styles.emblaContainer}>
                    {testimonials.map((testimonial, index) => (
                        <div className={styles.emblaSlide} key={index}>
                            <div
                                className={styles.testimonialContent}
                                style={{
                                    backgroundImage: testimonial.image ? `url(${testimonial.image})` : undefined,
                                }}
                            >
                                <div className={styles.testimonialCopy}>
                                    <Icon
                                        icon={faIcon({ name: "quote-left", style: "solid" })}
                                        className={styles.quoteIcon}
                                    />
                                    <blockquote className={styles.quote}>{testimonial.quote}</blockquote>
                                    <div className={styles.author}>
                                        <span className={styles.authorName}>{testimonial.author_name}</span>
                                        <span className={styles.authorTitle}>{testimonial.author_title}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {showNavigation && (
                <div className={styles.navigation}>
                    <IconButton
                        size="xl"
                        variant="subtle"
                        icon={faIcon({ name: "arrow-left", style: "regular" })}
                        onClick={scrollPrev}
                        aria-label="Previous testimonial"
                    />
                    <IconButton
                        size="xl"
                        variant="subtle"
                        icon={faIcon({ name: "arrow-right", style: "regular" })}
                        onClick={scrollNext}
                        aria-label="Previous testimonial"
                    />
                </div>
            )}
        </div>
    )
}
